// extracted by mini-css-extract-plugin
export default {"galleryFlex":"galleryFlex_fZ6WL","galleryContainer":"galleryContainer_DoRHv","editToggle":"editToggle_gWi0Z","triangle":"triangle_Phk0Q","active":"active_THLnC"};